import _ from "underscore";
import * as config from "../framework/config";
import * as Utils from "./utils";

export function getStores(query) {
    const url = config.get("stores.url") + "/summaries";
    return Utils.postJson(url, query.cleaned());
}

export function getStoreDetails(data) {
    const url = config.get("stores.url") + `/${data.id}`;
    return Utils.get(url);
}